/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PaymentTransactionReversalStatus_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.PaymentTransactionReversalStatus domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PaymentTransactionReversalStatus_ {
   /// <summary>
   ///   Pending Settlement (pend)
   /// </summary>
   Pending = 0,
   /// <summary>
   ///   Processing (proc)
   /// </summary>
   Processing = 1,
   /// <summary>
   ///   Succeeded (succ)
   /// </summary>
   Succeeded = 2,
   /// <summary>
   ///   Failed (fail)
   /// </summary>
   Failed = 3,
   /// <summary>
   ///   Rejected: Returned Unpaid (rjct)
   /// </summary>
   Rejected = 4
}

export const PaymentTransactionReversalStatuses: PaymentTransactionReversalStatus[] = [
   {
      code: PaymentTransactionReversalStatus_.Pending,
      literal: 'Pending',
      description: 'Pending Settlement',
      shortDescription: 'pend',
      listPriority: 0,

      typeName: "PaymentTransactionReversalStatus"
   },
   {
      code: PaymentTransactionReversalStatus_.Processing,
      literal: 'Processing',
      description: 'Processing',
      shortDescription: 'proc',
      listPriority: 0,

      typeName: "PaymentTransactionReversalStatus"
   },
   {
      code: PaymentTransactionReversalStatus_.Succeeded,
      literal: 'Succeeded',
      description: 'Succeeded',
      shortDescription: 'succ',
      listPriority: 0,

      typeName: "PaymentTransactionReversalStatus"
   },
   {
      code: PaymentTransactionReversalStatus_.Failed,
      literal: 'Failed',
      description: 'Failed',
      shortDescription: 'fail',
      listPriority: 0,

      typeName: "PaymentTransactionReversalStatus"
   },
   {
      code: PaymentTransactionReversalStatus_.Rejected,
      literal: 'Rejected',
      description: 'Rejected: Returned Unpaid',
      shortDescription: 'rjct',
      listPriority: 0,

      typeName: "PaymentTransactionReversalStatus"
   }
]

export class PaymentTransactionReversalStatus implements IDomainModel {
   code: PaymentTransactionReversalStatus_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PaymentTransactionReversalStatus_): PaymentTransactionReversalStatus {
      return PaymentTransactionReversalStatuses.find(d => d.code === code)
   }
}
